var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row align-items-center moregage-form" },
    [
      _c(
        "div",
        {
          staticClass:
            "col-xl-11 col-sm-11 col-12 order-lg-1 order-2 d-flex flex-column",
          class: {
            "column-divider-right campaigns-details-divider": _vm.label,
          },
        },
        [
          _c("div", { staticClass: "row mb-2 align-items-center" }, [
            _c("div", { staticClass: "col-12 col-lg-4" }, [
              _c(
                "p",
                { staticClass: "bold text-light-gray font-sm mb-2 mb-lg-0" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("campaigns.yourName")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-lg-8" },
              [
                _c("material-input", {
                  staticClass: "form-group-material-no-label",
                  attrs: {
                    label: _vm.$t("global.words.name"),
                    "hidden-label": "",
                    value: _vm.emailName,
                    disabled: _vm.noEdit,
                    placeholder: _vm.$t("global.words.name"),
                    "custom-expression": "emailName",
                  },
                  on: { change: _vm.handleEmailNameChange },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col-12 col-lg-4" }, [
              _c(
                "p",
                { staticClass: "bold text-light-gray font-sm mb-2 mb-lg-0" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("global.doorr.emailAddress")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-lg-8" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group-material form-group-material-no-label",
                      },
                      [
                        _c("marketing-emails-select", {
                          ref: "selectEmail",
                          attrs: {
                            disabled: _vm.noEdit,
                            value: _vm.fromData.email.emailId,
                            required: true,
                            multiple: false,
                            "material-design": true,
                            "space-classes": "col-12 p-0 mt-3",
                            emails: _vm.emails,
                          },
                          on: { change: _vm.selectEmail },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto align-self-end pb-4" }, [
                    _vm.save
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "text-uppercase font-sm bold text-primary clickable align-self-center mt-2",
                            attrs: { id: "create-email" },
                            on: { click: _vm.showCreateEmailModal },
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus text-primary" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("global.words.create"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-fade" } }, [
                  _vm.emailNotVerified
                    ? _c(
                        "div",
                        {
                          staticClass: "mt-2",
                          attrs: { id: "verify-container" },
                        },
                        [
                          _c("p", { staticClass: "text-regular-gray m-0" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("global.words.click", 1))
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "clickable text-primary",
                                attrs: { id: "verify-existing-email" },
                                on: { click: _vm.forceShowVerify },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("global.words.here")) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "campaigns.messages.toConfirmVerification"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.label
        ? _c(
            "div",
            {
              staticClass:
                "col-lg text-lg-center order-lg-2 order-1 mb-lg-0 mb-2",
            },
            [
              _c("p", { staticClass: "bold text-gray text-uppercase m-0" }, [
                _vm._v("\n      " + _vm._s(_vm.$t("email.from")) + "\n    "),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("create-email-modal", {
        ref: "createEmailModal",
        attrs: {
          "force-show-verify": _vm.showVerifyEmail,
          "force-email-to-verify": _vm.fromData.email,
        },
        on: {
          "close-modal": _vm.resetForceShowVerify,
          "auto-select-email": _vm.handleAutoSelectEmail,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }